import { get as _get } from 'lodash';
import { SiteContext } from '@nucleus/web-theme';
import { useContext } from 'react';

export const useSermonHubPath = (engineId?: string): string => {
  const { getSite } = useContext(SiteContext);
  const sermonHub = getSite().hubs.find((hub) => hub.id === engineId);
  return _get(sermonHub, 'paths[0]', '');
};
